import { Button, ButtonVariants } from '@components/button/Button';
import { useIsOpen } from '@shared/hooks/useIsOpen';
import styles from './RefundButton.scss';
import { RefundConfirmationModal } from './RefundConfirmationModal';

interface RefundButtonProps {
  reservationId: string;
  reservationPrice: number;
  isRefunded: boolean;
  buttonVariant?: ButtonVariants;
  disableModalPortal?: boolean;
  handleAfterConfirm?: () => void;
}

export const RefundButton = ({
  reservationId,
  reservationPrice,
  isRefunded,
  buttonVariant: variant = ButtonVariants.Error,
  disableModalPortal = true,
  handleAfterConfirm,
}: RefundButtonProps) => {
  const isFreeReservation = reservationPrice === 0;
  const {
    isOpen: isModalOpen,
    open: openModal,
    close: closeModal,
  } = useIsOpen();

  if (isRefunded) return null;
  if (isFreeReservation) return null;

  return (
    <>
      <Button
        className={styles.button}
        onClick={openModal}
        label="Refund"
        variant={variant}
      />
      <RefundConfirmationModal
        disablePortal={disableModalPortal}
        closeModal={closeModal}
        handleAfterConfirm={handleAfterConfirm}
        isOpen={isModalOpen}
        reservationId={reservationId}
      />
    </>
  );
};
